import React from "react";
import { withTranslation } from "react-i18next";
import { extractDurationAndUnit } from "components/common/TimeUnitInput";
import { describeExpression } from "util/CronUtils";
import { TIME_UNITS } from "./CorrelationForm";
const _CorrelationSummary = class _CorrelationSummary extends React.Component {
  render() {
    const { config, t } = this.props;
    const {
      sources,
      rules,
      search_within_ms: searchWithinMs,
      execute_every_ms: executeEveryMs,
      _is_scheduled: isScheduled,
      use_cron_scheduling: useCronScheduling,
      cron_expression: cronExpression,
      cron_timezone: cronTimezone
    } = config;
    const searchWithin = extractDurationAndUnit(searchWithinMs, TIME_UNITS);
    const executeEvery = extractDurationAndUnit(executeEveryMs, TIME_UNITS);
    return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, t("correlation_summary.correlate_within")), /* @__PURE__ */ React.createElement("dd", null, searchWithin.duration, " ", searchWithin.unit.toLowerCase()), /* @__PURE__ */ React.createElement("dt", null, t("correlation_summary.use_cron_scheduling")), /* @__PURE__ */ React.createElement("dd", null, useCronScheduling ? t("correlation_summary.yes") : t("correlation_summary.no")), useCronScheduling ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, t("correlation_summary.cron_expression")), /* @__PURE__ */ React.createElement("dd", null, cronExpression), /* @__PURE__ */ React.createElement("dt", null, t("correlation_summary.execute_correlation")), /* @__PURE__ */ React.createElement("dd", null, _CorrelationSummary.renderCronExpression(cronExpression, t)), /* @__PURE__ */ React.createElement("dt", null, t("correlation_summary.timezone")), /* @__PURE__ */ React.createElement("dd", null, cronTimezone)) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("dt", null, t("correlation_summary.execute_correlation_every")), /* @__PURE__ */ React.createElement("dd", null, executeEvery.duration, " ", executeEvery.unit.toLowerCase())), /* @__PURE__ */ React.createElement("dt", null, t("correlation_summary.enable_scheduling")), /* @__PURE__ */ React.createElement("dd", null, isScheduled ? t("correlation_summary.yes") : t("correlation_summary.no")), _CorrelationSummary.renderEvents(sources, rules, t));
  }
};
_CorrelationSummary.renderEvent = (source, rule, t) => {
  const notForPeriod = extractDurationAndUnit(rule.not_for_period, TIME_UNITS);
  let details;
  switch (rule.state_logic) {
    case "not_and":
      details = /* @__PURE__ */ React.createElement("dd", null, t("correlation_summary.not_and"));
      break;
    case "not_for":
      details = /* @__PURE__ */ React.createElement("dd", null, t("correlation_summary.not_for", {
        duration: notForPeriod.duration,
        unit: notForPeriod.unit.toLowerCase()
      }));
      break;
    default:
      details = /* @__PURE__ */ React.createElement("dd", null, t("correlation_summary.occurrence", { count: rule.occurrence }));
  }
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, /* @__PURE__ */ React.createElement("em", null, source.title || t("correlation_summary.no_event_assigned"))), details);
};
_CorrelationSummary.renderEvents = (sources, rules, t) => rules.map((rule, idx) => {
  const source = sources.find((s) => s.event_definition_id === rule.event_creator_equals) || {};
  return /* @__PURE__ */ React.createElement(React.Fragment, { key: rule.id }, /* @__PURE__ */ React.createElement("dt", null, t("correlation_summary.event_number", { number: idx + 1 })), _CorrelationSummary.renderEvent(source, rule, t));
});
_CorrelationSummary.renderCronExpression = (expression, t) => {
  if (expression) {
    return describeExpression(expression);
  }
  return t("correlation_summary.no_cron_expression");
};
let CorrelationSummary = _CorrelationSummary;
export default withTranslation("enterprise_security")(CorrelationSummary);
